import { atom } from 'recoil';

const now = new Date();

const selectedDateState = atom({
  key: 'selectedDate',
  default: now.toISOString().substring(0, 7),
});

export default selectedDateState;
